import { render, staticRenderFns } from "./AnswerProjectYears.vue?vue&type=template&id=2d2c0afa&"
import script from "./AnswerProjectYears.vue?vue&type=script&lang=js&"
export * from "./AnswerProjectYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports